<template>
    <a-table class='m-t-20' :pagination='false' :loading='listLoading' bordered rowKey='refund_warehousing_sn' :columns='columns' :data-source='list'>
        <template v-slot:action="{ record }">
            <a href="javascript:;" v-has:userCustomerInfoEdit="()=> {editInfo(record)}" class="m-r-10">编辑</a>
            <a href="javascript:;" v-has:userCustomerInfoDel="()=> {delInfo(record)}">删除</a>
        </template>
    </a-table>
    <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper
      :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange"
      @showSizeChange="pageSizeChange" />
        <!-- 会员的自定义信息-->
         <!-- 自定义信息-->
  <a-modal :keyboard="false" title="自定义信息" centered v-model:visible="visible" @ok="handleOk" destroyOnClose>
    <a-form :labelCol="{span:7}">
      <a-form-item label="自定义信息字段">
        <selectCustomerWord v-model:value="infoData.attach_field_id" :attach_field_id="infoData.attach_field_id" />
      </a-form-item>
      <a-form-item label="字段内容">
        <a-input v-model:value="infoData.attach_info" style="width:230px"></a-input>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import useTableSearch from "@/hooks/useTableSearch";
import {
  member_attach_info,
  updateMemberAttachInfo,
  createMemberAttachInfo,
  delMemberAttachInfo
} from "@/api/member";
import { onMounted, ref } from '@vue/runtime-core';
import { Modal } from 'ant-design-vue';
import { iscode } from '../../../../utils/app';
const defSearch={
    limit:10,
    page:1,
    user_id:""
}
const columns = [
      {
        title: "信息类型",
        dataIndex: "attach_field",
        key: "attach_field",
      },
      {
        title: "信息内容",
        dataIndex: "attach_info",
        key: "attach_info",
      },
      {
        title: "操作",
        key: "action",
        slots: { customRender: "action" },
      },
    ];
export default {
    props:{user_id:String || Number},
    setup(props){
    const {
        pageCurrentChange,
        pageSizeChange,
        search,
        list,
        initData,
        total,
        pageSearchChange,
        listLoading,
      } = useTableSearch({ data: defSearch });
      const tableHoosks = {
        pageCurrentChange,
        pageSizeChange,
        search,
        initData,
        list,
        total,
        pageSearchChange,
        listLoading,
      };
        onMounted(()=>{
            search.value.user_id=props.user_id
            tableHoosks.initData(member_attach_info,search.value)
        })
    var infoHandleHooks = () => {
      const visible = ref(false);
      const infoData = ref({ attach_info: "" });
      // 添加
      const createInfo = (data) => {
        infoData.value = { attach_info: "" };
        visible.value = true;
      };
      // 修改
      const editInfo = (data) => {
        infoData.value = JSON.parse(JSON.stringify(data));
        visible.value = true;
      };
      // 删除
      const delInfo = (data) => {
        Modal.confirm({
          centered: true,
          content: "删除后将无法恢复，您确定要删除吗？",
          onOk: async () => {
            let res = await delMemberAttachInfo(data.id).then((res) => res.data);
            if (iscode(res, true)) {
               tableHoosks.pageCurrentChange();
            }
          },
        });
      };
      // 确认
      const handleOk = async () => {
        let result;
        if (infoData.value.id) {
           result =await updateMemberAttachInfo(infoData.value.id,{...infoData.value,user_id:search.value.user_id}).then(res=>res.data).catch(error=>error)
        } else {
          console.log("添加");
           result =await createMemberAttachInfo({...infoData.value,user_id:search.value.user_id,}).then(res=>res.data).catch(error=>error)
        }
        if (iscode(result, true)) {
          visible.value = false;
              tableHoosks.pageCurrentChange();
        }
      };
      return {
        createInfo,
        visible,
        infoData,
        editInfo,
        handleOk,
        delInfo
      };
    };

      return{
          ...tableHoosks,
          ...infoHandleHooks(),
          columns
      }
    }
}
</script>